import { EsignFormType } from '@buyerflo/core/schemas/esign'
import { useMutation } from '@tanstack/react-query'
import { usePurchaserFilesApi } from 'apiProviders'
import Loading from 'components/Loading'
import Checkbox from 'components/checkbox'
import Modal, { dontCloseOnBackgroundClick } from 'components/modal'
import { useShowSnack } from 'components/snackbar'
import { useOrgId } from 'helpers'
import { usePurchaserContext } from 'purchasers/purchaserProvider'
import { useState } from 'react'
import Button from 'components/button'
import { Dialog, Text, View, YStack } from 'tamagui'
import { useTRPC } from 'utils/trpc'

interface Props {
    formType: EsignFormType | 'generic'
    open: boolean
    onClose: (data?: { editUrl: string; envelopeId: string }) => void
}

export default function AddAttachmentModal({ formType, open, onClose }: Props) {
    const { purchaser, setPurchaser } = usePurchaserContext()
    const showSnack = useShowSnack()
    const orgId = useOrgId()
    const filesApi = usePurchaserFilesApi({ excludeFolders: true })
    const trpc = useTRPC()

    const [s3Keys, sets3Keys] = useState<string[]>([])

    const locationRoot = `${orgId}/${purchaser.purchaserId}/files/`

    const createFormMutation = useMutation(trpc.esign.createForm.mutationOptions())

    return (
        <Modal
            open={open}
            onOpenChange={(open) => { if (!open) onClose() }}
        >
            <Dialog.Title>Add Attachments</Dialog.Title>
            <Dialog.Description asChild>
                <View paddingHorizontal="$2" marginTop="$2">
                    <YStack gap="$2">
                        {filesApi?.data?.length == 0 && (
                            <Text marginTop="$4">No PDF files uploaded to client</Text>
                        )}
                        {filesApi.data?.map(file => (
                            <Checkbox
                                key={file.Key}
                                checked={s3Keys.includes(file.Key)}
                                onChange={e => {
                                    if (e.target.checked) {
                                        sets3Keys([...s3Keys, file.Key])
                                    } else {
                                        sets3Keys(s3Keys.filter(x => x != file.Key))
                                    }
                                }}
                                label={file.Key.replace(locationRoot, '')}
                            />
                        ))}
                    </YStack>
                    {filesApi.data == undefined && <Loading />}
                </View>
            </Dialog.Description>
            <View gap="$2" flexDirection="row-reverse">
                <Button
                    disabled={createFormMutation.isPending}
                    onPress={async () => {
                        try {
                            const { updatedPurchaser, editUrl, envelopeId } =
                                await createFormMutation.mutateAsync({
                                    purchaserId: purchaser.purchaserId,
                                    formType: formType === 'generic' ? 'generic' : formType,
                                    s3Keys,
                                })
                            setPurchaser(updatedPurchaser)
                            onClose({ editUrl, envelopeId })
                        } catch (e) {
                            showSnack('Error creating form', 'danger')
                        }
                    }}
                >
                    Create
                </Button>
                <Button
                    variant="outlined"
                    onPress={() => onClose()}
                >
                    Cancel
                </Button>
            </View>
        </Modal>
    )
}
